module.exports = __webpack_public_path__ + "media/images/application/template/logo-e5d82e136b97b958fdf820a47d05e6f6.svg";